import { useEffect, useState } from 'react'
import { getTreeChanges } from '../../../services/userService'

export default function useTreeDetailChanges({ treeId }) {
  const [treeDetailChanges, setTreeDetailChanges] = useState([])

  useEffect(() => {
    const fetchTreeChanges = async () => {
      try {
        const response = await getTreeChanges(treeId)
        setTreeDetailChanges(response.data || [])
      } catch (error) {
        console.error('Error fetching tree changes:', error)
        setTreeDetailChanges([])
      }
    }

    if (treeId) {
      fetchTreeChanges()
    }
  }, [treeId])

  return { treeDetailChanges, setTreeDetailChanges }
}
